/* eslint-disable sonarjs/no-duplicate-string */
export const squeeze = {
  root: 'cur-max-w-[375px]',
  question: {
    title:
      'cur-font-heading cur-text-body cur-tracking-body cur-text-primary cur-font-bold cur-text-h2 cur-leading-8 cur-tracking-h2',
    description:
      'cur-mt-3 cur-font-body cur-text-body cur-tracking-body cur-leading-6 cur-text-primary cur-text-subtle cur-whitespace-pre-line',
    mainRoot: '',
    flowRoot: '',
    withFrame: 'cur-py-2',
    content: 'cur-mt-8 cur-mb-6',
    requiredText: 'cur-hidden',
  },
  panel: {
    title:
      'cur-font-heading cur-text-body cur-tracking-body cur-text-primary cur-font-bold cur-text-h2 cur-leading-8 cur-tracking-h2',
    description:
      'cur-mt-3 cur-font-body cur-text-body cur-tracking-body cur-leading-6 cur-text-primary cur-text-subtle cur-whitespace-pre-line',
    mainRoot: '',
    flowRoot: '',
    withFrame: 'cur-py-2',
    content: 'cur-mt-8 cur-mb-6',
    requiredText: 'cur-hidden',
  },
  comment:
    'cur-border-surface-disabled cur-p-3 cur-w-full cur-border-2 cur-ring-1 cur-ring-transparent cur-border-solid cur-rounded-sm cur-outline-none focus-visible:cur-border-focus focus-visible:cur-ring-focus',
  radiogroup: {
    root: 'cur-space-y-4',
  },
  checkbox: {
    root: 'cur-space-y-4 cur-mt-[-16px]',
  },
  actionBar: {
    root: 'cur-hidden',
  },
  error: {
    root: 'cur-hidden',
  },
};
